import IconContainer from '@/components/IconContainer'

export default function IconColorCancel(props) {
  return (
    <IconContainer {...props} width="28" height="28" ariaLabel="Cancel Icon">
      <circle cx="14" cy="14" r="10" fill="#FF6867" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05981 18.1121C8.83814 18.3337 8.83814 18.6931 9.05981 18.9148C9.28148 19.1365 9.64088 19.1365 9.86256 18.9148L13.9977 14.7797L18.1329 18.9149C18.3546 19.1365 18.714 19.1365 18.9356 18.9149C19.1573 18.6932 19.1573 18.3338 18.9356 18.1121L14.8004 13.9769L18.8897 9.8877C19.1113 9.66603 19.1113 9.30663 18.8897 9.08496C18.668 8.86328 18.3086 8.86328 18.0869 9.08496L13.9977 13.1742L9.90853 9.08502C9.68686 8.86335 9.32746 8.86335 9.10579 9.08502C8.88411 9.3067 8.88411 9.6661 9.10579 9.88777L13.1949 13.9769L9.05981 18.1121Z"
        fill="white"
      />
    </IconContainer>
  )
}
